import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileBottomBar } from "@/components/MobileBottomBar";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CookieBanner } from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
};

export const Layout = () => (
  <div className="App min-h-screen flex flex-col">
    <ScrollToTop />
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-brand-gold focus:text-brand-black focus:px-4 focus:py-2 focus:rounded-full focus:font-bold"
    >
      Aller au contenu principal
    </a>
    <Header />
    <main id="main-content" className="flex-1 pt-[72px] pb-20 md:pb-0">
      <Outlet />
    </main>
    <Footer />
    <MobileBottomBar />
    <WhatsAppButton />
    <CookieBanner />
    <Toaster position="top-center" richColors />
  </div>
);
